import { showToast } from '../../components/Toast';
import {
  addTransferFail,
  addTransferSuccess,
  deleteTransferFail,
  deleteTransferSuccess,
  hideLoading,
  showLoading,
  updateAgentFail,
  updateAgentSuccess,
  updateTransferFail,
  updateTransferSuccess
} from '../../store/transfers/actions';
import { transfersEuropeApi } from '../../services/TransfersService';
import { WsEvents } from '../events';
import { socket } from '../socket';

// export function onAddTransfer({ dispatch, combinedData }) {
//   dispatch(showLoading(true));
//   socket.emit(WsEvents.transfer.ADD, combinedData, callback);
//   function callback(res) {
//     if ('error' in res) {
//       dispatch(hideLoading(true));
//       // dispatch({ type: 'transfers/socketAddFail', error: res });
//       dispatch(addTransferFail(res));
//       return;
//     }
//     showToast('New Transfer is added');
//     const newTransfer = res[0];  // Assuming res[0] is the transfer
//     const newAgents = res[1];    // Optional: If you use agents elsewhere
//     dispatch(
//       transfersEuropeApi.util.updateQueryData('fetchLatestTransfers', combinedData[2], (draft) => {
//         draft.transfers.push(newTransfer);
//         // Optionally: update agents too if you cache that
//       })
//     );
//     // dispatch(addTransferSuccess(res));
//     dispatch(hideLoading(false));
//   }
// }

export function onAddTransfer({ dispatch, combinedData }) {
  dispatch(showLoading(true));

  socket.emit(WsEvents.transfer.ADD, combinedData, (res) => {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(addTransferFail(res)); // if you still keep this for error banner
      return;
    }

    showToast('New Transfer is added');

    // ⬇️ This is the key line: force every query with the 'transfers' tag to refresh
    dispatch(
      transfersEuropeApi.util.invalidateTags([{ type: 'transfers', id: 'LIST' }])
    );

    dispatch(hideLoading(false));
  });
}

export function onUpdateTransfer({ dispatch, updatedData }) {
  dispatch(showLoading(true));
console.log(updatedData)
  socket.emit(WsEvents.transfer.UPDATE, updatedData, (res) => {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(updateTransferFail(res)); // if you still keep this for error banner
      return;
    }

    showToast('Changes Successfully Applied');

    // ⬇️ This is the key line: force every query with the 'transfers' tag to refresh
    dispatch(
      transfersEuropeApi.util.invalidateTags([{ type: 'transfers', id: 'LIST' }])
    );

    dispatch(hideLoading(false));
  });
}

// export function onUpdateTransfer({ dispatch, updatedData }) {
//   dispatch(showLoading(true));
//   socket.emit(WsEvents.transfer.UPDATE, updatedData, callback);
//   function callback(res) {
//     if ('error' in res) {
//       dispatch(hideLoading(true));
//       dispatch(updateTransferFail(res));
//       return;
//     }
//     showToast('Changes Successfully Applied');
//     const [updatedTransfersOrOne, agents] = res;
//     dispatch(
//       transfersEuropeApi.util.updateQueryData('fetchLatestTransfers', updatedData.id, (draft) => {
//         const isBulk = Array.isArray(updatedTransfersOrOne);
//         if (isBulk) {
//           const updatesMap = updatedTransfersOrOne.reduce((map, transfer) => {
//             map[transfer._id] = transfer;
//             return map;
//           }, {});

//           draft.transfers = draft.transfers
//             .map((transfer) => updatesMap[transfer._id] ? { ...transfer, ...updatesMap[transfer._id] } : transfer)
//             .filter((t) => !(t.completed === true || t.agentPaid === true));
//         } else {
//           const updatedItem = updatedTransfersOrOne;
//           const index = draft.transfers.findIndex((t) => t._id === updatedItem._id);
//           if (index !== -1) {
//             draft.transfers[index] = {
//               ...draft.transfers[index],
//               ...updatedItem,
//             };
//           }
//         }
//         draft.agents = agents;
//       })
//     )
//     // dispatch(
//     //   transfersEuropeApi.util.updateQueryData('fetchLatestTransfers', updatedData[2], (draft) => {
//     //     const item = draft.transfers.find((row) => row._id === updatedData[0]._id);
//     //     if (item) {
//     //       Object.assign(item, updatedData[0]); // Apply changes optimistically
//     //     }
//     //   })
//     // );
//     // dispatch(updateTransferSuccess(res));
//     dispatch(hideLoading(false));
//   }
// }

export function onDeleteTransfer({ dispatch, deleteData }) {
  dispatch(showLoading(true));
console.log(deleteData)
  socket.emit(WsEvents.transfer.DELETE, deleteData, (res) => {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(deleteTransferFail(res)); // if you still keep this for error banner
      return;
    }

    showToast('Order is deleted from the system');

    // ⬇️ This is the key line: force every query with the 'transfers' tag to refresh
    dispatch(
      transfersEuropeApi.util.invalidateTags([{ type: 'transfers', id: 'LIST' }])
    );

    dispatch(hideLoading(false));
  });
}

// export function onDeleteTransfer({ dispatch, deleteData }) {
//   dispatch(showLoading(true));
//   socket.emit(WsEvents.transfer.DELETE, deleteData[0], callback);
//   function callback(res) {
//     if ('error' in res) {
//       dispatch(hideLoading(true));
//       // dispatch(deleteTransferFail(res));
//       return;
//     }
//     showToast('Order is deleted from the system');
//     // dispatch(deleteTransferSuccess(res));
//     dispatch(
//       transfersEuropeApi.util.updateQueryData('fetchLatestTransfers', deleteData[1], (draft) => {
//         if (!draft || !draft.transfers) return;
//         const index = draft.transfers.findIndex((row) => row._id === deleteData[0]._id);
//         if (index !== -1) {
//           draft.transfers.splice(index, 1); // Remove item optimistically
//         }
//       })
//     );
//     dispatch(hideLoading(false));
//   }
// }

export function onUpdateAgent({ dispatch, newAgentFee }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.agent.UPDATE, newAgentFee, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(updateAgentFail(res));
      return;
    }
    showToast('Changes Successfully Applied');
    dispatch(updateAgentSuccess(res));
    dispatch(hideLoading(false));
  }
}
